import React from 'react';
import { Spin } from 'antd';

const LoadingPage = () => (
  <div
    style={{
      display: 'flex',
      height: '100%',
      justifyContent: 'center',
      alignItems: 'center',
      padding: '20px',
    }}
  >
    <Spin size='large' tip='加载中...' spinning={true}>
      <div style={{ padding: '50px' }}></div>
    </Spin>
  </div>
);

export default LoadingPage;
